import { render, staticRenderFns } from "./FamilyEventManagement.vue?vue&type=template&id=16b14269&scoped=true"
import script from "./FamilyEventManagement.vue?vue&type=script&lang=js"
export * from "./FamilyEventManagement.vue?vue&type=script&lang=js"
import style0 from "./FamilyEventManagement.vue?vue&type=style&index=0&id=16b14269&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b14269",
  null
  
)

export default component.exports